import { EmptyState } from "@/components/portal";
import { createFileRoute } from "@tanstack/react-router";

const FORBIDDEN_TITLE = "Akses ditolak";
const FORBIDDEN_DESCRIPTION = "Akunmu tidak punya akses ke halaman ini.";

export const Route = createFileRoute("/403")({
	component: () => (
		<div className="k3a k3a-main">
			<EmptyState title={FORBIDDEN_TITLE} description={FORBIDDEN_DESCRIPTION} />
		</div>
	),
});
